import { personalizedSlipSchema } from "@redotech/redo-fulfillment-operations-common/personalized-slip/personalized-slip-definition";
import * as z from "zod";

export const updatePersonalizedSlipTemplate = {
  name: "updatePersonalizedSlipTemplate" as const,
  input: personalizedSlipSchema,
  output: z.intersection(
    personalizedSlipSchema,
    z.object({
      /** @deprecated Always 0; regeneration counts are no longer computed. */
      regeneratingInsertCount: z.number().nullish(),
    }),
  ),
};
